import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-searchable-dropdown',
  templateUrl: './searchable-dropdown.component.html',
  styleUrls: ['./searchable-dropdown.component.css'],
})
export class SearchableDropdownComponent {
  @Input() items: any[] = [];
  @Input() labelKey: string = 'name';
  @Input() placeholder: string = 'Rechercher...';
  @Input() selectedItem: any = null;
  @Input() displayLabel: boolean = false

  @Output() select = new EventEmitter<any>();
  @Output() inputChange = new EventEmitter<string>();

  searchQuery = '';
  toggleDropdown = false;
  filteredItems: any[] = [];

  filterItems() {
    const query = this.searchQuery.toLowerCase();
    this.filteredItems = this.items.filter((item) =>
      item[this.labelKey].toLowerCase().includes(query)
    );
    if (this.searchQuery === '' || this.searchQuery.length == 0) {
      this.selectedItem = null; // Reset selected item if search query is empty
    }
  }

  activateDropdown() {
    this.toggleDropdown = true;
    this.filteredItems = [...this.items]; // full list always on focus
    console.log(this.items);
    console.log(this.labelKey);
    this.items.forEach((item) => {
      console.log(item[this.labelKey]);

    })
  }

  deactivateDropdown() {
    this.toggleDropdown = false;
  }

  selectItem(item: any) {
    console.log('Item selected:', item); // ⬅️ Add this
    this.selectedItem = item;
    this.searchQuery = item[this.labelKey];
    this.filteredItems = [];
    this.toggleDropdown = false;
    this.select.emit(item);
  }
  passInputChange() {
    this.inputChange.emit(this.searchQuery);
  }
}
